import React from "react";
import PropTypes from "prop-types";
// Sections

// Limitless imports
import TemplateRenderer from "../../components/template-renderer/TemplateRenderer";
import QuizIntroduction from "../../sections/quiz-introduction/QuizIntroduction";
import QuizCta from "../../sections/quiz-cta/QuizCta";
import QuizQuestion from "../../sections/quiz-question/QuizQuestion";
const SECTIONS = {
  introduction: QuizIntroduction,
  "mc-quiz-question1": QuizQuestion,
  "mc-quiz-question": QuizQuestion,
  "quiz-cta": QuizCta
};
const MultipleChoiceQuizTemplate = ({
  content,
  quizState,
  quizCtaClick,
  disableQuizCta,
  isOnboardingView,
  handleAnswerChange
}) => {
  if (!content || !content.sections) {
    return null;
  }
  return /*#__PURE__*/React.createElement(TemplateRenderer, {
    content: content,
    quizState: quizState,
    sectionComponentMapping: SECTIONS,
    quizCtaClick: quizCtaClick,
    disableQuizCta: disableQuizCta,
    isOnboardingView: isOnboardingView,
    handleAnswerChange: handleAnswerChange
  });
};
export default MultipleChoiceQuizTemplate;
MultipleChoiceQuizTemplate.propTypes = {
  content: PropTypes.object.isRequired,
  quizState: PropTypes.object,
  retryContent: PropTypes.func,
  noAttemptLeftContent: PropTypes.func,
  successContent: PropTypes.func,
  quizCtaClick: PropTypes.func,
  disableQuizCta: PropTypes.bool,
  isOnboardingView: PropTypes.bool,
  handleAnswerChange: PropTypes.func
};